import { Component, Input, OnInit } from '@angular/core';
import TYPES from '../history.event.types';
import { ContactHistory } from '../../contacts-details.model';
import { HistoryService } from '../history.service';
import { getMsisdnlabel } from '../../../shared/utils/msisdn-label';

@Component({
  selector: 'cc-history-header',
  templateUrl: './history-header.component.html',
  styleUrls: ['./history-header.component.scss']
})
export class HistoryHeaderComponent implements OnInit {
  @Input() mainTitle: string;
  @Input() event: ContactHistory;
  @Input() active: boolean;
  @Input() showIcon: boolean;
  @Input() date: string;
  public msisdn: string;
  public label: string;
  public numberLabel: string;
  public getPhoneNumberLabel = getMsisdnlabel;
  constructor(public historyService: HistoryService) {}

  ngOnInit() {
    this.getSubtitleValuesForOutbound();
  }

  getSubtitleValuesForOutbound() {
    this.msisdn = this.event && this.event.historicalCallerId ? this.event.historicalCallerId : '';
    this.label = this.event && this.event.labelCallerId ? this.event.labelCallerId : '';
  }

  getTranslateValue() {
    return TYPES[this.mainTitle] ? TYPES[this.mainTitle].label : this.mainTitle;
  }

  getIsoCountry(number: string) {
    return this.historyService.getIsoCountry(number);
  }
}
